import { ERouteUrl } from 'router/config';

export const searchDebounceTime = 500;

export const allMenuIsHidden = (pathname: string) => !['/login', '/', '/restore-password'].includes(pathname);

const printPageUrlRegexp = /^(\/print\/\d+)$/;
const success = /^(\/sberid\/\D+)$/;
const error = /^(\/sberid\/error\D+)$/;
const printPageAgreement = /^(\/print\/\d+\/agreement\/\D+)$/;
const passportInfoPage = /^(\/passportInfo\/)/g;

export const isPrintPage = (pathname: string) =>
  pathname.match(printPageUrlRegexp) ||
  pathname.match(printPageAgreement) ||
  pathname.match(success) ||
  pathname.match(error) ||
  pathname.match(passportInfoPage);

export const pagesToShowMenuButton = [
  ERouteUrl.USER_LIST,
  ERouteUrl.PZU_LIST,
  ERouteUrl.PZU_INFO,
  ERouteUrl.PSA_LIST,
  ERouteUrl.PAYMENT_LIST,
  ERouteUrl.LZ_LIST,
  ERouteUrl.LZ_PRICES,
  ERouteUrl.LZ_BUSINESS_CARD,
  ERouteUrl.LZ_BUSINESS_ID,
  ERouteUrl.LZ_METAL,
  ERouteUrl.LZ_INFO,
  ERouteUrl.PZU_BUSINESS_CARD,
  ERouteUrl.PZU_PERSONALS,
  ERouteUrl.PZU_PRICES,
  ERouteUrl.TRANSACTION_LIST,
  ERouteUrl.NEWS,
];
